import { H2 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import useCalculateCategoriesCount from '@/hooks/useCalculateCategoriesCount';
import { useAppSelector } from '@/redux/hooks';
import { featuredCategoriesSelector, featuredCategoriesTitleSelector } from '@/redux/modules/featuredCategories';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import CategoryCard from './CategoryCard';
import { CategoryModuleCard } from './CategoryModuleCard';

type Props = {
    className?: string;
    shouldUseHomePageRedesign?: boolean;
    testid?: string;
};

export const CategoryModule = ({ className, shouldUseHomePageRedesign = false, testid }: Props) => {
    const formatMessage = useAppFormatMessage();
    const title = useAppSelector(featuredCategoriesTitleSelector);
    const categories = useAppSelector(featuredCategoriesSelector);
    const categoryCount = useCalculateCategoriesCount();
    const categoriesToShow = categories.slice(0, categoryCount);

    return categoriesToShow.length ? (
        <div
            className={cn('relative flex w-full flex-col items-center self-center text-center', className)}
            data-testid={testid}
        >
            <H2 className={cn('w-full', shouldUseHomePageRedesign ? 'mb-sm text-center' : 'text-left')}>
                {title || formatMessage(['browse_by_category'])}
            </H2>
            <div
                className={cn(
                    'w-full overflow-hidden',
                    shouldUseHomePageRedesign
                        ? 'grid grid-cols-2 gap-sm smMin:flex smMin:gap-md'
                        : 'flex flex-wrap justify-between'
                )}
            >
                {categoriesToShow.map(({ imageUrl, link, title: categoryTitle }) =>
                    shouldUseHomePageRedesign ? (
                        <CategoryModuleCard
                            imageUrl={imageUrl}
                            key={categoryTitle}
                            link={link}
                            title={categoryTitle}
                        />
                    ) : (
                        <CategoryCard
                            imageUrl={imageUrl}
                            key={categoryTitle}
                            link={link}
                            title={categoryTitle}
                        />
                    )
                )}
            </div>
        </div>
    ) : null;
};
